/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type SubscriptionAdditionalPaymentData,
    SubscriptionAdditionalPaymentDataFromJSON,
    SubscriptionAdditionalPaymentDataToJSON,
} from '../models/SubscriptionAdditionalPaymentData';
import {
    type SubscriptionPackage,
    SubscriptionPackageFromJSON,
    SubscriptionPackageToJSON,
} from '../models/SubscriptionPackage';
import {
    type UpdateSubscriptionInput,
    UpdateSubscriptionInputFromJSON,
    UpdateSubscriptionInputToJSON,
} from '../models/UpdateSubscriptionInput';

export interface CancelSubscriptionAtPeriodEndRequest {
    projectId: string;
}

export interface ChangeSubscriptionRequest {
    projectId: string;
    packageId: string;
    updateSubscriptionInput?: UpdateSubscriptionInput;
}

export interface CheckSubscriptionPaymentSetupRequest {
    projectId: string;
}

export interface GetSubscriptionChangePriceRequest {
    projectId: string;
    packageId: string;
    billingCycle: GetSubscriptionChangePriceBillingCycleEnum;
}

/**
 * 
 */
export class SubscriptionApi extends runtime.BaseAPI {

    /**
     * Creates request options for cancelSubscriptionAtPeriodEnd without sending the request
     */
    async cancelSubscriptionAtPeriodEndRequestOpts(requestParameters: CancelSubscriptionAtPeriodEndRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling cancelSubscriptionAtPeriodEnd().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/subscription/cancel`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Schedules cancellation at the end of the trial or paid period.
     */
    async cancelSubscriptionAtPeriodEndRaw(requestParameters: CancelSubscriptionAtPeriodEndRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.cancelSubscriptionAtPeriodEndRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Schedules cancellation at the end of the trial or paid period.
     */
    async cancelSubscriptionAtPeriodEnd(requestParameters: CancelSubscriptionAtPeriodEndRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelSubscriptionAtPeriodEndRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for changeSubscription without sending the request
     */
    async changeSubscriptionRequestOpts(requestParameters: ChangeSubscriptionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling changeSubscription().'
            );
        }

        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError(
                'packageId',
                'Required parameter "packageId" was null or undefined when calling changeSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/subscribe/{packageId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{packageId}', encodeURIComponent(String(requestParameters['packageId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubscriptionInputToJSON(requestParameters['updateSubscriptionInput']),
        };
    }

    /**
     * Create or change a subscription for a project.
     */
    async changeSubscriptionRaw(requestParameters: ChangeSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.changeSubscriptionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create or change a subscription for a project.
     */
    async changeSubscription(requestParameters: ChangeSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.changeSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for checkSubscriptionPaymentSetup without sending the request
     */
    async checkSubscriptionPaymentSetupRequestOpts(requestParameters: CheckSubscriptionPaymentSetupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling checkSubscriptionPaymentSetup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/subscription/check-payment-setup`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Check subscription payment setup.
     */
    async checkSubscriptionPaymentSetupRaw(requestParameters: CheckSubscriptionPaymentSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ErrorResponse>> {
        const requestOptions = await this.checkSubscriptionPaymentSetupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseFromJSON(jsonValue));
    }

    /**
     * Check subscription payment setup.
     */
    async checkSubscriptionPaymentSetup(requestParameters: CheckSubscriptionPaymentSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ErrorResponse> {
        const response = await this.checkSubscriptionPaymentSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSubscriptionChangePrice without sending the request
     */
    async getSubscriptionChangePriceRequestOpts(requestParameters: GetSubscriptionChangePriceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getSubscriptionChangePrice().'
            );
        }

        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError(
                'packageId',
                'Required parameter "packageId" was null or undefined when calling getSubscriptionChangePrice().'
            );
        }

        if (requestParameters['billingCycle'] == null) {
            throw new runtime.RequiredError(
                'billingCycle',
                'Required parameter "billingCycle" was null or undefined when calling getSubscriptionChangePrice().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['billingCycle'] != null) {
            queryParameters['billingCycle'] = requestParameters['billingCycle'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/subscribe/{packageId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{packageId}', encodeURIComponent(String(requestParameters['packageId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find out if an additional payment is needed to change the subscription
     */
    async getSubscriptionChangePriceRaw(requestParameters: GetSubscriptionChangePriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionAdditionalPaymentData>> {
        const requestOptions = await this.getSubscriptionChangePriceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionAdditionalPaymentDataFromJSON(jsonValue));
    }

    /**
     * Find out if an additional payment is needed to change the subscription
     */
    async getSubscriptionChangePrice(requestParameters: GetSubscriptionChangePriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionAdditionalPaymentData> {
        const response = await this.getSubscriptionChangePriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPublicSubscriptionPackages without sending the request
     */
    async listPublicSubscriptionPackagesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/subscription-packages`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the non-archived public subscription package catalog.
     */
    async listPublicSubscriptionPackagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionPackage>>> {
        const requestOptions = await this.listPublicSubscriptionPackagesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionPackageFromJSON));
    }

    /**
     * Returns the non-archived public subscription package catalog.
     */
    async listPublicSubscriptionPackages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionPackage>> {
        const response = await this.listPublicSubscriptionPackagesRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetSubscriptionChangePriceBillingCycleEnum = {
    Monthly: 'monthly',
    Annual: 'annual'
} as const;
export type GetSubscriptionChangePriceBillingCycleEnum = typeof GetSubscriptionChangePriceBillingCycleEnum[keyof typeof GetSubscriptionChangePriceBillingCycleEnum];
